import type { CSSProperties, PropsWithChildren } from 'react'

export type DefinitionListItemProps = UiComponentProps &
  PropsWithChildren & {
    isBold?: boolean
    /** Visible on mobile only; rendered as a `<dt>` by `DefinitionList`. */
    label?: string
    style?: CSSProperties
  }

/**
 * Composition marker for `DefinitionList`.
 * Children and props are read from JSX by `DefinitionList` and are not rendered by this component.
 */
export function DefinitionListItem(_props: DefinitionListItemProps) {
  return null
}

DefinitionListItem.displayName = 'DefinitionList.Item'
